import * as gzIconDirective from './icon.directive';

export default angular.module('gazelle.components.icon', [])
  .directive(gzIconDirective.name, gzIconDirective.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/icon/icon.module.js